import React from "react";

// Import logo correctly based on your folder structure: ../../assets/
import logo from "../../assets/img/logo/logo.png";

const SidebarPopup = () => {
  return (
    <div>
      <div className="sidebar-popup">
        <div className="sidebar-wrapper">
          <div className="sidebar-content">
            <button type="button" className="close-sidebar-popup">
              <i className="far fa-xmark"></i>
            </button>

            <div className="sidebar-logo">
              <img src={logo} alt="Logo" />
            </div>

            <div className="sidebar-about">
              <h4>About Us</h4>
              <p>
                There are many variations of passages available sure there
                majority have suffered alteration in some form by injected
                humour or randomised words which don't look even slightly
                believable.
              </p>
            </div>

            <div className="sidebar-contact">
              <h4>Contact Info</h4>
              <ul>
                <li>
                  <h6>Email</h6>
                  <a href="/cdn-cgi/l/email-protection#a38a8d858ca3869b828e938f86cd808c8e">
                    <i className="far fa-envelope"></i>
                    <span
                      className="__cf_email__"
                      data-cfemail="5f363139301f3a273e322f333a713c3032"
                    >
                      [email&nbsp;protected]
                    </span>
                  </a>
                </li>
                <li>
                  <h6>Phone</h6>
                  <a href="tel:+21236547898">
                    <i className="far fa-phone"></i>+2 123 654 7898
                  </a>
                </li>
                <li>
                  <h6>Address</h6>
                  <a href="#">
                    <i className="far fa-location-dot"></i>25/B Milford Road,
                    New York
                  </a>
                </li>
              </ul>
            </div>

            <div className="sidebar-social">
              <h4>Follow Us</h4>
              <a href="#">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidebarPopup;
